import React from 'react';

import { useIntl } from '@edx/frontend-platform/i18n';
import {
  Form, FormAutosuggest, FormAutosuggestOption, FormControlFeedback,
} from '@edx/paragon';
import PropTypes from 'prop-types';

import validateCityField, { CITY_CODE_KEY, CITY_DISPLAY_KEY } from './validator';
import messages from '../../messages';

const CityField = (props) => {
  const {
    cityList,
    selectedCity,
    onChangeHandler,
    handleErrorChange,
    onFocusHandler,
    errorMessage,
  } = props;
  const { formatMessage } = useIntl();
  const handleOnBlur = (event) => {
    // Do not run validations when drop-down arrow is clicked
    if (event.relatedTarget && event.relatedTarget.className.includes('pgn__form-autosuggest__icon-button')) {
      return;
    }

    const { value } = event.target;

    const { cityCode, displayValue, error } = validateCityField(
      value.trim(), cityList, formatMessage(messages['empty.country.field.error']),
    );

    onChangeHandler({ target: { name: 'city' } }, { cityCode, displayValue });
    handleErrorChange('city', error);
  };

  const handleSelected = (value) => {
    handleOnBlur({ target: { name: 'city', value } });
  };

  const handleOnFocus = (event) => {
    handleErrorChange('city', '');
    // dispatch(clearRegistrationBackendError('city'));
    onFocusHandler(event);
  };

  const handleOnChange = (value) => {
    onChangeHandler({ target: { name: 'city' } }, value);
  };

  const getCityList = () => cityList.map((city) => (
    <FormAutosuggestOption key={`${city[CITY_DISPLAY_KEY]} + ${city[CITY_CODE_KEY]}`}>
      {city[CITY_DISPLAY_KEY]}
    </FormAutosuggestOption>
  ));
  return (
    <div className="form-field select-city form-type">
      <Form.Label className="label-text-small">{formatMessage(messages['customized.courses.city.label'])} ({formatMessage(messages['customized.courses.optional.label'])})</Form.Label>
      <FormAutosuggest
        className="input-inline"
        aria-label="form autosuggest"
        name="city"
        value={selectedCity.displayValue || ''}
        onSelected={(value) => handleSelected(value)}
        onFocus={(e) => handleOnFocus(e)}
        onBlur={(e) => handleOnBlur(e)}
        onChange={(value) => handleOnChange(value)}
        trailingElement=""
      >
        {getCityList()}
      </FormAutosuggest>
      {errorMessage !== '' && (
        <div className={`${errorMessage !== '' ? 'mt-2' : ''}`}>
          <FormControlFeedback type="default" id="city-error" feedback-for="city" key="error" className={`${errorMessage ? '' : 'hidden' } form-text-size label-text-small p-1 tip tip-input`}>
            <span>
              {errorMessage}
            </span>
          </FormControlFeedback>
        </div>
      )}
    </div>
  );
};

CityField.propTypes = {
  cityList: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      name: PropTypes.string,
    }),
  ).isRequired,
  errorMessage: PropTypes.string,
  onChangeHandler: PropTypes.func.isRequired,
  handleErrorChange: PropTypes.func.isRequired,
  onFocusHandler: PropTypes.func.isRequired,
  selectedCity: PropTypes.shape({
    displayValue: PropTypes.string,
    cityCode: PropTypes.string,
  }),
};

CityField.defaultProps = {
  errorMessage: null,
  selectedCity: {
    value: '',
  },
};

export default CityField;
